var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Author',{attrs:{"author-info":_vm.authorData}}),_c('MaybePic'),(_vm.navTree.length !== 0)?_c('MarkdownTree',{attrs:{"tree-data":_vm.navTree}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }